import { ApolloProvider } from '@apollo/client';
import PropTypes from 'prop-types';
import React from 'react';
import client from './networkedClient';

const Provider = ({ children }) => {
  // ensure our old cache key is removed to avoid it hogging local storage space
  // (we explored this library for doing offline support, before going with RxDB)
  window.localStorage.removeItem('apollo-cache-persist');

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

Provider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  loading: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
};

export default Provider;
